export class Anchor {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.styleId = 1
    this.styleType = "horizontal"
    this.width = 300
    this.height = 44
    this.left = 0
    this.top = 0
    this.innerElement = "cxAnchorComponent"

    // 字体
    this.fontFamily = "sans-serif"
    this.activeFontFamily = "sans-serif"
    this.hoverFontFamily = "sans-serif"
    this.liFontFamily = "sans-serif"
    this.liActiveFontFamily = "sans-serif"
    this.liHoverFontFamily = "sans-serif"
    this.fontSize = 16
    this.activeFontSize = 16
    this.hoverFontSize = 16
    this.liFontSize = 16
    this.liActiveFontSize = 16
    this.liHoverFontSize = 16
    this.fontWeight = 400
    this.activeFontWeight = 400
    this.hoverFontWeight = 400
    this.liFontWeight = 400
    this.liActiveFontWeight = 400
    this.liHoverFontWeight = 400
    this.color = "rgba(0,0,0,1)"
    this.activeColor = "rgba(255,255,255,1)"
    this.hoverColor = "rgba(255,255,255,1)"
    this.liFontColor = "rgba(0,0,0,1)"
    this.liActiveFontColor = "rgba(255,255,255,1)"
    this.liHoverFontColor = "rgba(255,255,255,1)"
    this.textIsThemeColor = false
    this.activeTextIsThemeColor = false
    this.hoverTextIsThemeColor = false
    this.liTextIsThemeColor = false
    this.liActiveTextIsThemeColor = false
    this.liHoverTextIsThemeColor = false
    this.bgColor = "#EDEDED"
    this.activeBgColor = "#3D82F2"
    this.hoverBgColor = "#3D82F2"
    this.lineHeight = 44
    this.activeLineHeight = 44
    this.hoverLineHeight = 44
    this.liLineHeight = 44
    this.liActiveLineHeight = 44
    this.liHoverLineHeight = 44
    this.letterSpacing = 0
    this.activeLetterSpacing = 0
    this.hoverLetterSpacing = 0
    this.liLetterSpacing = 0
    this.liActiveLetterSpacing = 0
    this.liHoverLetterSpacing = 0
    this.fontStyle = "normal"
    this.activeFontStyle = "normal"
    this.hoverFontStyle = "normal"
    this.liFontStyle = "normal"
    this.liActiveFontStyle = "normal"
    this.liHoverFontStyle = "normal"
    this.textAlign = "left"
    this.activeTextAlign = "left"
    this.hoverTextAlign = "left"
    this.liTextAlign = "left"
    this.liActiveTextAlign = "left"
    this.liHoverTextAlign = "left"
    this.writingMode = "horizontal-tb"
    this.activeWritingMode = "horizontal-tb"
    this.hoverWritingMode = "horizontal-tb"
    this.liWritingMode = "horizontal-tb"
    this.liActiveWritingMode = "horizontal-tb"
    this.liHoverWritingMode = "horizontal-tb"
    this.textDecoration = "none"
    this.activeTextDecoration = "none"
    this.hoverTextDecoration = "none"
    this.liTextDecoration = "none"
    this.liActiveTextDecoration = "none"
    this.liHoverTextDecoration = "none"

    // 边框
    this.showBorder = false
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#000000"
    this.borderStyle = "solid"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.showHoverBorder = false
    this.hoverBorderTopLeftRadius = 0
    this.hoverBorderTopRightRadius = 0
    this.hoverBorderBottomLeftRadius = 0
    this.hoverBorderBottomRightRadius = 0
    this.hoverBorderColor = "#000000"
    this.hoverBorderStyle = "solid"
    this.hoverBorderWidth = 0
    this.hoverBorderIsThemeColor = false
    this.showActiveBorder = false
    this.activeBorderTopLeftRadius = 0
    this.activeBorderTopRightRadius = 0
    this.activeBorderBottomLeftRadius = 0
    this.activeBorderBottomRightRadius = 0
    this.activeBorderColor = "#000000"
    this.activeBorderStyle = "solid"
    this.activeBorderWidth = 0
    this.activeBorderIsThemeColor = false
    this.liShowBorder = false
    this.liBorderTopLeftRadius = 0
    this.liBorderTopRightRadius = 0
    this.liBorderBottomLeftRadius = 0
    this.liBorderBottomRightRadius = 0
    this.liBorderColor = "#000000"
    this.liBorderStyle = "solid"
    this.liBorderWidth = 0
    this.liBorderIsThemeColor = false
    this.liHoverShowBorder = false
    this.liHoverBorderTopLeftRadius = 0
    this.liHoverBorderTopRightRadius = 0
    this.liHoverBorderBottomLeftRadius = 0
    this.liHoverBorderBottomRightRadius = 0
    this.liHoverBorderColor = "#000000"
    this.liHoverBorderStyle = "solid"
    this.liHoverBorderWidth = 0
    this.liHoverBorderIsThemeColor = false
    this.liActiveShowBorder = false
    this.liActiveBorderTopLeftRadius = 0
    this.liActiveBorderTopRightRadius = 0
    this.liActiveBorderBottomLeftRadius = 0
    this.liActiveBorderBottomRightRadius = 0
    this.liActiveBorderColor = "#000000"
    this.liActiveBorderStyle = "solid"
    this.liActiveBorderWidth = 0
    this.liActiveBorderIsThemeColor = false

    this.anchorWidth = 98
    this.anchorHeight = 44
    this.anchorWidthType = "px"
    this.anchorHeightType = "px"
    this.anchorBackgroundColor = "#EDEDED"
    this.anchorMarginRight = 40
    this.activeIndex = "0"
    this.hoverUnderlineStyle = "solid"
    this.hoverUnderlineColor = "#fff"
    this.hoverUnderlineWidth = 1
    this.anchorList = [
      { content: "锚点1", target: null, hide: false, children: [] },
      { content: "锚点2", target: null, hide: false, children: [] },
      { content: "锚点3", target: null, hide: false, children: [] }
    ]
    this.bgColorIsThemeColor = false
    this.hoverBgColorIsThemeColor = true
    this.opacity = 100
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.allBgColor = "rgba(255,255,255,0)" // 全局背景色
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.allBorderTopLeftRadius = 0
    this.allBorderTopRightRadius = 0
    this.allBorderBottomLeftRadius = 0
    this.allBorderBottomRightRadius = 0
    this.allBorderWidth = 0
    this.allBorderStyle = "solid"
    this.allBorderColor = "#000000"
    this.allBorderIsThemeColor = false
    this.contentHasLimit = false
    this.textLimitLines = 4
    this.paddingTypeFlag = 1
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.iconWidth = 14
    this.marginRight = 0
    this.marginBottom = 0
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
